module.exports = __webpack_public_path__ + "img/pen-alt-solid updated.cbf0ac1d.svg";